export default __webpack_public_path__ + "static/media/flag.cbd35679.jpg";